export const stripHtml = (originalString: string) : string => originalString.replace(/(<([^>]+)>)/gi, '');
